import { createReducer, on } from '@ngrx/store';
import {
  ActiveComponentChanged,
  ResetStateFromRouter,
} from 'src/app/shared/actions/eliqua.actions';
import {
  ExecuteConfigurationFailed,
  ExecuteConfigurationSuccess,
  SaveConfigurationFailed,
  SaveConfigurationSuccess,
} from '../actions/bulk-add-new.actions';
import {
  ButtonPointerEventDisabled,
  ButtonPointerEventEnabled,
  DropZoneDisabled,
  DropZoneEnabled,
  DryRunChanged,
  EmptyNewBulkOp,
  FileToUploadChanged,
  GetDisplayedColumns,
  GetFile,
  GetFileTableRows,
  RemoveFile,
  UploadedFileChanged,
  UploadingFile,
} from '../actions/new-bulk-operations.actions';
import { NewBulkOperation } from '../actions/side-nav.actions';
import { NewBulkOperationState } from '../models/bulk.models';

const initialState: NewBulkOperationState = {
  configuration: '',
  file: '',
  groupName: '',
  description: '',
  profileModel: '',
  supportedFile: '',
  filesFirstLine: '',
  profileModelKey: '',
  buttonEventsDisabled: false,
  enteredDropZone: false,
  uploadedFile: { name: '', size: 0, lines: 0 },
  fileTableRows: '',
  headers: '',
  displayedColumns: [],
  maxPreviewLines: 5,
  delimiter: '',
  dryRun: false,
  fileToUpload: '',
  deleteFlag: false,
  uploading: false,
  emailNotification: '',
};

export const NewBulkOperationReducer = createReducer(
  initialState,
  on(NewBulkOperation, (state, { row }) => {
    let displayedColumns: string[] = Array.from(
      {
        length: row.importConfigurationDto.importMapping.filter(
          (column: any) =>
            !!column.profileColumnName || !!column.attributeCode || !!column.flowFieldCode,
        ).length,
      },
      (_, index) => `col${index}`,
    );
    let headers = displayedColumns.reduce((acc: any, col: string, index: number) => {
      acc[col] =
        index < row.importConfigurationDto.importMapping.length
          ? {
              attribute: row.importConfigurationDto.importMapping[index].attribute,
              selectedModelProperty:
                row.importConfigurationDto.importMapping[index].profileColumnName,
              sqlOption: row.importConfigurationDto.importMapping[index].columnStatus,
              attributeType: row.importConfigurationDto.importMapping[index].attributeType,
              attributeCode: row.importConfigurationDto.importMapping[index].attributeCode,
              flowField: row.importConfigurationDto.importMapping[index].flowField,
              extraFieldCode: row.importConfigurationDto.importMapping[index].flowFieldCode,
              profileColumnPosition:
                row.importConfigurationDto.importMapping[index].profileColumnPosition,
            }
          : '';
      return acc;
    }, {});

    return {
      ...state,
      configuration: row,
      groupName: row.importTitle,
      description: row.importConfigurationDto.importConfigurationDescription,
      profileModel: row.importModelProfile,
      supportedFile: row.importConfigurationDto.fileNamePattern,
      filesFirstLine: row.importConfigurationDto.withHeader ? 'Header' : 'Data',
      profileModelKey: row.importConfigurationDto.modelProfile.profileModelList[0].modelKey,
      delimiter: row.importConfigurationDto.importFileType.config,
      dryRun: row.importConfigurationDto.dryRun,
      emailNotification: row.importConfigurationDto.emailNotification,
      headers,
    };
  }),
  on(ActiveComponentChanged, (state) => ({
    ...state,
  })),
  on(ButtonPointerEventEnabled, (state) => ({
    ...state,
    buttonEventsDisabled: false,
  })),
  on(ButtonPointerEventDisabled, (state) => ({
    ...state,
    buttonEventsDisabled: true,
  })),
  on(DropZoneEnabled, (state) => ({
    ...state,
    enteredDropZone: true,
  })),
  on(DropZoneDisabled, (state) => ({
    ...state,
    enteredDropZone: false,
  })),
  on(UploadedFileChanged, (state, { name, size, lines }) => ({
    ...state,
    uploadedFile: { name: name, size: size, lines: lines },
  })),
  on(GetFile, (state, { file }) => ({
    ...state,
    file,
  })),
  on(GetDisplayedColumns, (state, { cols }) => {
    let displayedColumns: string[] = Array.from({ length: cols }, (_, index) => `col${index}`);
    return {
      ...state,
      displayedColumns,
    };
  }),
  on(GetFileTableRows, (state, { fileTableRows }) => ({
    ...state,
    fileTableRows,
  })),
  on(DryRunChanged, (state) => ({
    ...state,
    dryRun: !state.dryRun,
  })),
  on(RemoveFile, (state) => ({
    ...state,
    file: '',
    uploadedFile: { name: '', size: 0, lines: 0 },
    fileTableRows: '',
    displayedColumns: [],
    headers: '',
  })),
  on(FileToUploadChanged, (state, { fileToUpload }) => ({
    ...state,
    fileToUpload,
  })),
  on(UploadingFile, (state) => ({
    ...state,
    uploading: true,
  })),
  on(SaveConfigurationSuccess, (state) => ({
    ...state,
    uploading: false,
  })),
  on(SaveConfigurationFailed, (state) => ({
    ...state,
    uploading: false,
  })),
  on(ExecuteConfigurationSuccess, (state) => ({
    ...state,
    uploading: false,
  })),
  on(ExecuteConfigurationFailed, (state) => ({
    ...state,
    uploading: false,
  })),
  on(EmptyNewBulkOp, () => initialState),
  on(ResetStateFromRouter, () => ({
    ...initialState,
  })),
);
